import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Portal from 'react-portal';
import _delay from 'lodash/delay';

import './style.scss';

export default class ActionsMenu extends Component {
  static propTypes = {
    entry: PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
      order: PropTypes.number,
    }),
    position: PropTypes.shape({
      left: PropTypes.string,
      top: PropTypes.string,
    }),

    onAddEntryBefore: PropTypes.func,
    onAddEntryAfter: PropTypes.func,
    onDeleteEntry: PropTypes.func,
    onClose: PropTypes.func,
  };

  handleAddBefore = () => {
    // TODO: Drop this when moving list to React
    _delay(() => {
      this.props.onAddEntryBefore(this.props.entry.order);
    }, 100);

    this.props.onClose();
  };

  handleAddAfter = () => {
    _delay(() => {
      this.props.onAddEntryAfter(this.props.entry.order);
    }, 100);

    this.props.onClose();
  };

  handleDelete = () => {
    this.props.onDeleteEntry(this.props.entry);
    this.props.onClose();
  };

  render() {
    return (
      <Portal
        closeOnEsc
        closeOnOutsideClick
        isOpened
        onClose={this.props.onClose}
      >
        <div styleName="root" style={this.props.position}>
          <div styleName="list">
            <button onClick={this.handleAddBefore} data-test="add-before">
              Add new row above
            </button>
            <button onClick={this.handleAddAfter} data-test="add-after">
              Add new row below
            </button>
            <hr />
            <button onClick={this.handleDelete} data-test="delete">
              Delete Row
            </button>
          </div>
        </div>
      </Portal>
    );
  }
}
